
import _ from 'lodash';

import { ContextBarContent } from './content.js';

const unwrap = require('./util/unwrap.js');

const template = require('../templates/content-calc-working.html');


export class ContentCalcWorking extends ContextBarContent {
	constructor (options) {
		options = _.defaultsDeep(options || {}, {
			name: 'calc-working',
			above: ['default'],
			calcWorking: {
				progress: 1, // 0 <= progress <= 1
				message: 'пожалуйста, подождите',
			},
		});

		super(options);

		_.defaults(this, {
			template: {
				html: template(),
				data: this,
			},
		});
	}

	_normalizedProgress () {
		const p = unwrap(this._options.calcWorking.progress);
		return _.round(100 * Math.max(Math.min(p, 1), 0));
	}

	_message () {
		return unwrap(this._options.calcWorking.message);
	}
}